import script from "./Perfil.vue?vue&type=script&setup=true&lang=js"
export * from "./Perfil.vue?vue&type=script&setup=true&lang=js"

import "./Perfil.vue?vue&type=style&index=0&id=37a4280c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37a4280c"]])

export default __exports__